import { useBifrostMachine } from '../components/bifrost-machine-provider';

export default useBifrostMachine;
